import React from 'react'
import Text from '../textStyleDefault/texto'

interface Valor {
  titulo: string
  texto: string
  icono?: string // Cambiar a JSX.Element para iconos React
}

type listas = Valor[]

interface ListaDescripcionesProps {
  items: listas
  iconosComponentes?: boolean // Prop para mostrar los iconos
}

const ListaDescripciones = (props: ListaDescripcionesProps): any => {
  return (
    <div className="flex flex-col w-full md:gap-y-[40px] gap-y-[22px] md:mt-0 mt-[24px]">
      {props.items.map((valor, index) => (
        <div key={index} className="w-full flex flex-col text-start gap-[16px]">
          <div className="flex items-center gap-2">
            {props.iconosComponentes === true && (
              <img src={valor.icono} alt="icono" className="" />
            )}
            <Text variant='beneficiosTitulo1' className="mb-1 leading-[25px] tracking-[0.03px]">{valor.titulo}</Text>
          </div>
          <Text as="p" variant="beneficiosParrafo" className="tracking-[0.024px] w-full mr-20 leading-[125%]">
            {valor.texto}
          </Text>
        </div>
      ))}
    </div>
  )
}

export default ListaDescripciones
